var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2641_1952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0C14.3121 0 0 14.3134 0 32C0 49.6879 14.3134 64 32 64C49.6879 64 64 49.6866 64 32C64 14.3121 49.6865 0 32 0ZM32 59C17.0759 59 5 46.9231 5 32C5 17.0759 17.0769 5 32 5C46.9241 5 59 17.0769 59 32C59 46.9241 46.923 59 32 59Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 26.7913C30.6193 26.7913 29.5 27.9105 29.5 29.2913V45.3904C29.5 46.7711 30.6193 47.8904 32 47.8904C33.3807 47.8904 34.5 46.771 34.5 45.3903V29.2913C34.5 27.9105 33.3807 26.7913 32 26.7913Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 23.73C33.864 23.73 35.375 22.2189 35.375 20.355C35.375 18.491 33.864 16.98 32 16.98C30.136 16.98 28.625 18.491 28.625 20.355C28.625 22.2189 30.136 23.73 32 23.73Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2641_1952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.ef4805ebb3e04d267f894739c1e8ca1d.svg";
export { ForwardRef as ReactComponent };